/**
 * Formats an array of validation messages into a single string: strips trailing periods, trims each message, joins with newlines.
 */
export const formatValidationMessages = (messages: string[]): string =>
  messages.map((m) => m.replace(/\.$/, '').trim()).join('\n');
